import React, { useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography, MenuItem, Button } from "@mui/material";
import axios from "axios";
import './index.css'; 
import { UPLOAD_VOLUNTEER_DATA } from '../../../api/volunteer.js';
const VolunteerForm = ({ open, onClose }) => {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "", lastName: "", userType: "", organization: "",
    allottedTime: "", city: "", email: "", phone: "", reason: "",
  });

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    try {
      await axios.post(UPLOAD_VOLUNTEER_DATA, formData);
      setSubmitted(true);
      setTimeout(() => {
        onClose();
        setSubmitted(false);
        setFormData({ firstName: "", lastName: "", userType: "", organization: "", allottedTime: "", city: "", email: "", phone: "", reason: "" });
      }, 6000);
    } catch (error) {
      console.error("Submission error", error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ className: "volunteer-dialog-paper" }}>
      <DialogTitle className="volunteer-title">Volunteer Registration</DialogTitle>
      <DialogContent>
        {!submitted ? (
          <div className="form-grid-container">
            <div className="form-row-split">
              <TextField label="First Name" name="firstName" fullWidth className="form-input-field" onChange={handleChange} />
              <TextField label="Last Name" name="lastName" fullWidth className="form-input-field" onChange={handleChange} />
            </div>
            <TextField select label="Are you a..." name="userType" fullWidth className="form-input-field" value={formData.userType} onChange={handleChange}>
              <MenuItem value="student">Student</MenuItem>
              <MenuItem value="professional">Professional</MenuItem>
              <MenuItem value="founder">Founder</MenuItem>
            </TextField>
            <TextField label="Organization" name="organization" fullWidth className="form-input-field" onChange={handleChange} />
            <TextField select label="Time Commitment" name="allottedTime" fullWidth className="form-input-field" value={formData.allottedTime} onChange={handleChange}>
              <MenuItem value="4">Monthly 4 hrs</MenuItem>
              <MenuItem value="8">Monthly 8 hrs</MenuItem>
              <MenuItem value="12">Monthly 12 hrs</MenuItem>
            </TextField>
            <TextField label="City" name="city" fullWidth className="form-input-field" onChange={handleChange} />
            <TextField label="Email ID" name="email" fullWidth className="form-input-field" onChange={handleChange} />
            <TextField label="Contact Number" name="phone" fullWidth className="form-input-field" onChange={handleChange} />
            <TextField label="Reason to contribute" name="reason" fullWidth multiline rows={4} className="form-input-field" onChange={handleChange} />
          </div>
        ) : (
          <div className="success-message-box">
            <Typography variant="h6" className="success-header">Thank you for showing your interest!</Typography>
            <Typography variant="body1" className="success-body">Your profile will be verified and we will contact you if shortlisted.</Typography>
          </div>
        )}
      </DialogContent>
      {!submitted && (
        <DialogActions className="form-actions-group">
          <Button onClick={onClose} className="btn-cancel">Cancel</Button>
          <Button onClick={handleSubmit} variant="contained" className="btn-submit-volunteer">Submit Request</Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default VolunteerForm;